/**
 * Per-app "remember my email" persistence over a single localStorage key. The
 * password is never stored; storage failures (private mode) degrade silently.
 * Each app passes its own key so the apps never share a remembered address.
 */
export interface RememberedEmail {
  /** The remembered address, or '' when none is stored / storage is blocked. */
  readonly initial: string;
  /** Persist a freshly-entered address (no-op when blank). Call only after a correct login. */
  remember(value: string): void;
}

export function rememberedEmail(key: string): RememberedEmail {
  let initial = '';
  try {
    initial = localStorage.getItem(key) ?? '';
  } catch {
    /* storage unavailable (private mode) — leave empty */
  }
  return {
    initial,
    remember(value: string): void {
      const email = value.trim();
      if (!email) {
        return;
      }
      try {
        localStorage.setItem(key, email);
      } catch {
        /* storage unavailable (private mode) — skip silently */
      }
    },
  };
}
